import { Adapter } from './adapter';
import { get, isNil } from 'lodash';

const dstm = window.dstm || {};

export class ShiftDigitalTagManagerAdapter extends Adapter {
  static get #defaultOptions() {
    return {
      dataLayerName: 'dataLayer',
    };
  }

  get type() {
    return 'shift_digital';
  }

  constructor({ logger, adapterOptions = {} }) {
    super({ logger: logger.withPrefix('shift_digital') });

    adapterOptions = {
      ...ShiftDigitalTagManagerAdapter.#defaultOptions,
      ...adapterOptions,
    };

    this.dataLayerName = adapterOptions.dataLayerName;
    this.log('adapter configured', { adapterOptions });
  }

  trackEvent(eventName, eventData) {
    this.logEvent(`custom-tracking:${eventName}`, {
      eventName,
      eventData,
    });

    this.send({ events: eventName, ...eventData });
  }

  trackClick(event, eventName, eventData) {
    this.logEvent(event.type, 'trackClick', {
      event,
      eventName,
      eventData,
    });

    this.send({ events: eventName, ...eventData });
  }

  trackFormEvent(event, $form, eventName, eventData) {
    const convertedFieldData = this.convertDataToFieldData(eventData, $form);

    const vehicleDetails = get(window.sdDataLayer || {}, 'vehicleDetails');
    if (!isNil(vehicleDetails)) {
      dstm.logger.debug('setting `formVehicle` in event data', { formVehicle: vehicleDetails });
      convertedFieldData.formVehicle = vehicleDetails;
    }

    this.logEvent(event.type, 'trackFormEvent', {
      event,
      $form,
      eventName,
      eventData,
      convertedFieldData,
    });

    this.send({ events: eventName, ...convertedFieldData });
  }

  trackFormSubmit(event, $form, onSubmitEventName = 'formSubmission', onSubmitEventData = {}) {
    const convertedFieldData = this.convertDataToFieldData(onSubmitEventData, $form);

    const vehicleDetails = get(window.sdDataLayer || {}, 'vehicleDetails');
    if (!isNil(vehicleDetails)) {
      dstm.logger.debug('setting `formVehicle` in event data', { formVehicle: vehicleDetails });
      convertedFieldData.formVehicle = vehicleDetails;
    }

    this.logEvent(event.type, 'trackFormSubmit', {
      event,
      $form,
      onSubmitEventName,
      onSubmitEventData,
      convertedFieldData,
    });

    this.send({ events: onSubmitEventName, ...convertedFieldData });
  }

  trackGFFormConfirmation(event, formId) {
    this.logEvent(event.type, 'trackGFFormConfirmation', {
      event,
      formId,
    });
  }

  send(data) {
    if (!window.sd) {
      throw new Error('Could not send event via SD tag manager');
    }

    this.log('send', { ...data });

    const sd = window.sd || function () {};
    sd(this.dataLayerName, { ...data });
    sd('send');
  }
}
